<div class="vertical-list-container">    
@for (item of videos(); track item.id) {  
    <div class="video-item" (click)="videoClick.emit(item)" [class.selected]="selectedVideo() && selectedVideo()?.id === item.id">
        <img [src]="item.thumbnailUrl" >

        <div>
            <p class="info">{{item.title}}</p>
            <span class="date">{{item.date | date : "MMM d, y"}}</span>
        </div>
    </div>
}
</div>